import React, { useState } from "react";

import { useQuery, useLazyQuery } from "@apollo/client";
import PropTypes from "prop-types";
import { RULES } from "shared/graphql/rule/queries";
import { useInfo } from "utils/hooks/info";

import View from "./View";

const Component = ({ setActiveStep, item, onChange }) => {
  const {
    commonInfo: { unknownProductCode },
  } = useInfo();
  const [warranty, setWarranty] = useState();

  const [getRules, query] = useLazyQuery(RULES);
  const queryWarranty = useQuery(RULES, {
    variables: {
      where: {
        invoiceLine: item.receiptLinekey,
        productCode: item.productCode || unknownProductCode,
        ruleType: "WARRANTY",
      },
    },
    onCompleted: (result) => {
      const warrantyCodeParams =
        result?.rules?.data?.warrantyTypes[0]?.warrantyCode;
      setWarranty(result?.rules?.data?.warrantyTypes[0]?.warrantyDesc);
      getRules({
        variables: {
          where: {
            invoiceLine: item.receiptLinekey,
            productCode: item.productCode || unknownProductCode,
            ruleType: "INTERVENTION_TYPES",
            warrantyCode: warrantyCodeParams,
          },
        },
      });
    },
  });

  return (
    <View
      setActiveStep={setActiveStep}
      query={query}
      onChange={onChange}
      product={item}
      queryWarranty={queryWarranty}
      warranty={warranty}
    />
  );
};

Component.propTypes = {
  onChange: PropTypes.func.isRequired,
  setActiveStep: PropTypes.func.isRequired,
  item: PropTypes.shape({
    productCode: PropTypes.string.isRequired,
  }).isRequired,
};

Component.defaultProps = {};

export default Component;
